import { createSlice } from '@reduxjs/toolkit'
import { defaultTo } from 'ramda'
import { dataAnalyticsSignalId } from '../Utils/DataAnalytics'

const slice = createSlice({
  name: 'dataAnalyticsEventSignalOverviewValues',
  initialState: {},
  reducers: {
    setOverviewSignalValues: (state, { payload }) => {
      state[`${payload.eventId}`] = {
        ...defaultTo({}, state[`${payload.eventId}`]),
        [dataAnalyticsSignalId(payload)]: {
          data: payload.data,
        }
      }
    },
  },
})

export const { setOverviewSignalValues } = slice.actions

export default slice.reducer

export const selectOverviewSignalValues = (eventId) => (state) =>
  state.dataAnalyticsEventSignalOverviewValues[eventId]
